import { getBackboneWindow } from '../getBackboneWindow'

export const unsetPostEditorDragListener = (): void => {
  getBackboneWindow()?.OpalMoments_m.PostShroud.Radio.trigger(
    'asset:drag:rearrange:start'
  )
}

export const resetPostEditorDragListener = (): void => {
  getBackboneWindow()?.OpalMoments_m.PostShroud.Radio.trigger(
    'asset:drag:rearrange:stop'
  )
}
